export const categories = [
  {
    label: 'Music',
  },
  {
    label: 'Games',
  },
  {
    label: 'Sports',
  },
  {
    label: 'Arts',
  },
  {
    label: 'Film',
  },
  {
    label: 'Literature',
  },
  {
    label: 'Technology',
  },
  {
    label: 'Culture',
  },
  {
    label: 'Lifestyle',
  },
  {
    label: 'Charity',
  },
  {
    label: 'Faishon',
  },
  {
    label: 'Kids',
  },
  {
    label: 'Other',
  },
];
